import React, { useId } from 'react';

export default function ArtstashDamIcon() {
  const gradientId = useId().replace(/:/g, '');

  return (
    <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
      <path d="M9 1.875L1.875 5.625L9 9.375L16.125 5.625L9 1.875Z" stroke={`url(#${gradientId}-paint0)`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M1.875 12.375L9 16.125L16.125 12.375" stroke={`url(#${gradientId}-paint1)`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M1.875 9L9 12.75L16.125 9" stroke={`url(#${gradientId}-paint2)`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <defs>
        <linearGradient id={`${gradientId}-paint0`} x1="1.5" y1="1.5" x2="16.5" y2="16.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5B6CFF"/>
          <stop offset="0.5" stopColor="#9B45E8"/>
          <stop offset="1" stopColor="#FF3DA6"/>
        </linearGradient>
        <linearGradient id={`${gradientId}-paint1`} x1="1.5" y1="1.5" x2="16.5" y2="16.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5B6CFF"/>
          <stop offset="0.5" stopColor="#9B45E8"/>
          <stop offset="1" stopColor="#FF3DA6"/>
        </linearGradient>
        <linearGradient id={`${gradientId}-paint2`} x1="1.5" y1="1.5" x2="16.5" y2="16.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#5B6CFF"/>
          <stop offset="0.5" stopColor="#9B45E8"/>
          <stop offset="1" stopColor="#FF3DA6"/>
        </linearGradient>
      </defs>
    </svg>
  );
}
